<script>
    import RideMap from '@js/components/maps/RideMap.svelte';

    const {
        ride
    } = $props();
</script>

<RideMap mapId={`map-${ride.id}`}
         rideId={ride.id}
         rideName={ride.name}
         rideShareUrl={ride.shareUrl}
         ridePoisCount={ride.poisCount}
         initialLocation={ride.coordinates}/>
